import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Alert from '../../common/Alert';
import { confirmAlert } from 'react-confirm-alert';
import Modal from './Modal';
import { Link } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import { tenantAgencyContacts, tenantSupportEmail } from '../../common/constants/tenant';
import { getUsersBrowserVersion } from '../../common/utils';
import isEmpty from 'lodash/isEmpty';

export class Header extends Component {
  static propTypes = {
    tenantName: PropTypes.string.isRequired,
    logoUrl: PropTypes.string.isRequired,
    agencyHeaderUrl: PropTypes.string,
    supportedBrowserVersions: PropTypes.any.isRequired,
  };

  displayContactsModal = () => {
    confirmAlert({
      customUI: ({ onClose }) => (
        <Modal
          header="Contact Information"
          onClose={onClose}
          className="modal maxh-full height-auto maxw-desktop"
        >
          <div className="padding-x-2">
            <h2> Support Contacts </h2>
            <ul className="usa-list">
              {tenantSupportEmail[this.props.tenantName] && (
                <li>
                  Main email for assistance with accounts:{' '}
                  <a
                    className="usa-link"
                    href={`mailto:${tenantSupportEmail[this.props.tenantName]}`}
                  >
                    {tenantSupportEmail[this.props.tenantName]}
                  </a>
                </li>
              )}
              <li>
                Specific emails for assistance with applications and licenses:
                <ul className="usa-list">
                  {' '}
                  {tenantAgencyContacts[this.props.tenantName] &&
                    tenantAgencyContacts[this.props.tenantName].map(agency => (
                      <li>
                        {agency.name} -{' '}
                        <a className="usa-link" href={`mailto:${agency.email}`}>
                          {' '}
                          {agency.email}{' '}
                        </a>
                      </li>
                    ))}
                </ul>
              </li>
            </ul>
            {onClose && (
              <button id="close-button" className="usa-button margin-y-3" onClick={onClose}>
                {' '}
                Close{' '}
              </button>
            )}
          </div>
        </Modal>
      ),
    });
  };

  render() {
    const { logoUrl, websiteUrl, agencyLoginUrl, t, supportedBrowserVersions } = this.props;
    const { name, version } = getUsersBrowserVersion();

    const supportedBrowserAlertMsg =
    <a className="usa-link" href="/supported-browsers"> Visit our list of supported browsers </a>;

    const isSupportedBrowser = supportedBrowserVersions && supportedBrowserVersions[name.toLowerCase()];

    return (
      <div>
        {!isEmpty(supportedBrowserVersions) && !isSupportedBrowser && (

          <Alert
              id="browserAlert"
              heading="Please use a supported browser for best performance."
              message={supportedBrowserAlertMsg}
                type="warning"
              fade={false}
          />
        )}
        <header className="usa-header usa-header--basic common-header">
          <div className="grid-container-widescreen common-header__nav-container">
            <div className="usa-nav-container padding-top-1 padding-bottom-1">
              <div className="usa-navbar border-0">
                <div className="usa-logo common-header__logo" id="basic-logo">
                  <a href={websiteUrl} title="Home" aria-label="Home">
                    <img src={logoUrl} alt="tenant-logo" />
                  </a>
                </div>
                <button className="usa-menu-btn margin-left-1">Menu</button>
              </div>
              <nav aria-label="Primary navigation" className="usa-nav">
                <button className="usa-nav__close">X</button>
                <ul className="usa-nav__primary usa-accordion desktop:margin-bottom-1">
                  <li className="usa-nav__primary-item">
                    <Link className="common-header__header-link" to="/faq">
                      <span>{t('header.faq_btn')}</span>
                    </Link>
                  </li>
                  <li className="usa-nav__primary-item">
                    <button
                      id="save"
                      className="usa-button usa-button--unstyled common-header__header-link"
                      onClick={this.displayContactsModal}
                    >
                      Contact
                    </button>
                  </li>
                  <li className="usa-nav__primary-item">
                    <a className="common-header__header-link" href={agencyLoginUrl}>
                      <span> {t('header.agency_login_btn')}</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </header>
      </div>
    );
  }
}


/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

export default withNamespaces('common')(Header);




// WEBPACK FOOTER //
// ./src/features/common/Header.js